import React from 'react';
import Icon from '../../../../Assets/Icon/CustomIcon';
import { statusBadgeClass } from './PermitList';

/**
 * PermitHeaderCard
 * 상단 프로필 요약 카드 (M_PER_NEW_02 detail / 입회 모드 공통 사용)
 */
export default function PermitHeaderCard({ mst, extReturnDetail }) {
  return (
    <section className="rounded-2xl border border-[#becab7]/20 bg-white p-6 shadow-sm">
      <div className="mb-4 flex items-start justify-between">
        <div className="space-y-1">
          <span
            className={`text-2xs inline-block rounded-full px-3 py-1 font-extrabold tracking-wider text-white uppercase ${statusBadgeClass[mst?.status] || 'bg-slate-500'}`}
          >
            {mst?.status || '-'}
          </span>
          <h2 className="font-headline text-2xl font-extrabold tracking-tight text-[#191c1e]">
            {mst?.reqNm || '-'}{' '}
            <span className="text-sm font-medium text-[#3f4a3b]">
              ({mst?.reqPosition || '담당자'})
            </span>
          </h2>
        </div>
        <div className="flex h-14 w-14 items-center justify-center overflow-hidden rounded-full border-2 border-[#dcf9d7] bg-[#f2f4f6]">
          {mst?.photo ? (
            <img
              alt="profile"
              className="h-full w-full object-cover"
              src={mst.photo}
            />
          ) : (
            <Icon.Person width="32" height="32" color="#3f4a3b" />
          )}
        </div>
      </div>

      <div className="space-y-2 text-sm font-semibold text-[#3f4a3b]">
        <div className="flex items-center gap-3">
          <span className="text-[#5ABD4F]">
            <Icon.Notes width="20" height="20" />
          </span>
          <p>{mst?.workContent}</p>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-[#5ABD4F]">
            <Icon.Location width="20" height="20" />
          </span>
          <p>{mst?.workLoc || '장소 정보 없음'}</p>
        </div>
      </div>
      {['반려', '연장반려'].includes(mst?.status) && (
        <div className="mt-4 rounded-xl border border-red-100 bg-red-50 p-3">
          <p className="mb-1 text-xs font-bold text-red-500">
            {mst.status === '반려' ? '반려 사유' : '연장 반려 사유'}
          </p>
          <p className="text-sm font-medium text-red-700">
            {(mst.status === '반려' ? mst.returnDetail : extReturnDetail) ||
              '-'}
          </p>
        </div>
      )}
    </section>
  );
}
